export default __webpack_public_path__ + "static/media/5.b5645f88.svg";